import { TextField, FormControl, Select, MenuItem, Grid } from "@mui/material";
import { useCallback, useEffect, useState } from "react";
import addYears from "date-fns/addYears";
import InputMask from "react-input-mask";

const PersonalInfo = ({ page, setPage, formData, setFormData }) => {
    const currentDate = new Date();
    const min19Years = addYears(currentDate, -19);

    const [addressError, setAddressError] = useState(null);
    const [cityError, setCityError] = useState(null);
    const [postalError, setPostalError] = useState(null);
    const [provinceError, setProvinceError] = useState(null);
    const [emailError, setEmailError] = useState(null);
    const [firstNameError, setFirstNameError] = useState(null);
    const [lastNameError, setLastNameError] = useState(null);
    const [phoneError, setPhoneError] = useState(null);
    const [birthdateError, setBirthdateError] = useState(null);
    // const [showDisclaimer, setShowDisclaimer] = useState(false);

    const preventNonPositiveInteger = (e) => {
        if (e.key === "e" || e.key === "." || e.code === 'Minus' || e.code === 'ArrowUp' || e.code === 'ArrowDown') {
            e.preventDefault();
        }
    };
    const preventPaste = (e) => {
        e.preventDefault();
    };

    const onFirstNameChange = (e) => {
        setFormData({ ...formData, firstName: e.target.value })
        setFirstNameError(null);
    }
    const onLastNameChange = (e) => {
        setFormData({ ...formData, lastName: e.target.value })
        setLastNameError(null);
    }
    const onAddressChange = (e) => {
        setFormData({ ...formData, address: e.target.value });
        setAddressError(null);
    }
    const onCityChange = (e) => {
        setFormData({ ...formData, city: e.target.value });
        setCityError(null);
    }
    const onPostalCodeChange = (e) => {
        setFormData({ ...formData, postalCode: e.target.value.toUpperCase() });
        setPostalError(null);
    }
    const onProvinceChange = (e) => {
        setFormData({ ...formData, state: e.target.value });
        setProvinceError(null);
    }
    const onEmailChange = (e) => {
        setFormData({ ...formData, email: e.target.value });
        setEmailError(null);
    }
    const onPhoneChange = (e) => {
        if (e.target.value.length > 10) {
            e.preventDefault(e);
        } else {
            setFormData({ ...formData, cellPhone: e.target.value });
        }
        setPhoneError(null);
    }
    const onBirthdateChange = (e) => {
        setFormData({ ...formData, dob: e.target.value });
        setBirthdateError(null);
    }

    //email validator regex
    const isEmailValid = (mail) => {
        return (/\S+@\S+\.\S+/.test(mail));
    }

    const updateFormData = useCallback(() => {
        setFormData(formData);
        // if (formData.state === "QC") {
        //     setShowDisclaimer(true);
        // } else {
        //     setShowDisclaimer(false);
        // }
    }, [formData, setFormData]);

    useEffect(() => {
        updateFormData();
    }, [updateFormData]);

    useEffect(() => {
        setAddressError(null);
        setCityError(null);
        setPostalError(null);
        setProvinceError(null);
        setEmailError(null);
        setFirstNameError(null);
        setLastNameError(null);
        setPhoneError(null);
        setBirthdateError(null);
    }, [formData.lang]);

    const moveToTop = () => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    }

    const validateData = () => {
        var valid = true;

        if (formData.firstName === "") {
            setFirstNameError(formData.lang === "fr" ? "Ceci est nécessaire" : "This field is required");
            valid = false;
        } else {
            setFirstNameError(null);
        }

        if (formData.lastName === "") {
            setLastNameError(formData.lang === "fr" ? "Ceci est nécessaire" : "This field is required");
            valid = false;
        } else {
            setLastNameError(null);
        }

        if (formData.address === "") {
            setAddressError(formData.lang === "fr" ? "Ceci est nécessaire" : "This field is required");
            valid = false;
        } else {
            setAddressError(null);
        }

        if (formData.city === "") {
            setCityError(formData.lang === "fr" ? "Ceci est nécessaire" : "This field is required");
            valid = false;
        } else {
            setCityError(null);
        }

        if (formData.postalCode === "") {
            setPostalError(formData.lang === "fr" ? "Ceci est nécessaire" : "This field is required");
            valid = false;
        } else if (formData.postalCode.length < 6) {
            setPostalError(formData.lang === "fr" ? "Six caractères sont requis (pas d'espaces)" : "Six characters are required (no spaces)");
            valid = false;
        } else {
            setPostalError(null);
        }

        if (formData.state === "") {
            setProvinceError(formData.lang === "fr" ? "Requis" : "Required");
            // setShowDisclaimer(false);
            valid = false;
        } else {
            // setShowDisclaimer(false);
            setProvinceError(null);
        }

        if (formData.email === "") {
            setEmailError(formData.lang === "fr" ? "Ceci est nécessaire" : "This field is required");
            valid = false;
        } else if (isEmailValid(formData.email) === false) {
            setEmailError(formData.lang === "fr" ? "Format d'e-mail valide requis" : "Valid email format required");
            valid = false;
        } else {
            setEmailError(null);
        }

        if (formData.cellPhone === "") {
            setPhoneError(formData.lang === "fr" ? "Ceci est nécessaire" : "This field is required");
            valid = false;
        } else if (formData.cellPhone.length !== 10) {
            setPhoneError(formData.lang === "fr" ? "Doit contenir 10 chiffres (sans espace ni tiret)" : "Must be 10 digits (no space or hyphens)");
            valid = false;
        } else {
            setPhoneError(null);
        }

        if (formData.dob === "") {
            setBirthdateError(formData.lang === "fr" ? "Une date de naissance valide est requise" : "Valid birthdate is required");
            valid = false;
        } else if (Date.parse(formData.dob) > Date.parse(min19Years)) {
            setBirthdateError(formData.lang === "fr" ? "Il faut avoir au moins 19 ans" : "You must be at least 19 years old");
            valid = false;
        } else if (Date.parse(formData.dob) > Date.parse(currentDate)) {
            setBirthdateError(formData.lang === "fr" ? "La date saisie est postérieure à la date actuelle" : "Date entered is after current date");
            valid = false;
        } else {
            setBirthdateError(null);
        }

        if (valid === true) {
            // if (formData.state === "QC" && formData.requestedAmount > 2000) {
            //     setFormData({ ...formData, requestedAmount: 2000 });
            // }

            window.dataLayer.push({'event': 'loan_step7', 'loanEvent': 'step7', 'loanEventID': 8});
            // quebec only
            // window.dataLayer.push({'event': 'loan_step7q', 'loanEvent': 'step7q', 'loanEventID': '8q'});

            setPage(page + 1);
            moveToTop();
        }
    }

    return (
        <div className="card">
            <div className="card-div">
                <Grid container spacing={1}>
                    <Grid item xs={6}>
                        <div className="textfield-label">{formData.lang === "fr" ? "Prénom" : "First Name"}</div>
                        <TextField
                            autoComplete="given-name"
                            variant="outlined"
                            value={formData.firstName}
                            onChange={onFirstNameChange} />
                        <div className="error-text">{firstNameError}</div>
                    </Grid>
                    <Grid item xs={6}>
                        <div className="textfield-label">{formData.lang === "fr" ? "Nom de famille" : "Last Name"}</div>
                        <TextField
                            autoComplete="family-name"
                            variant="outlined"
                            value={formData.lastName}
                            onChange={onLastNameChange} />
                        <div className="error-text">{lastNameError}</div>
                    </Grid>
                </Grid>
                <div className="textfield-label">{formData.lang === "fr" ? "Adresse" : "Address"}</div>
                <TextField
                    variant="outlined"
                    value={formData.address}
                    onChange={onAddressChange}
                    autoComplete="address-line1" />
                <div className="error-text">{addressError}</div>
                <Grid container spacing={1}>
                    <Grid item xs={5}>
                        <div className="textfield-label">{formData.lang === "fr" ? "Ville" : "City"}</div>
                        <TextField
                            variant="outlined"
                            value={formData.city}
                            onChange={onCityChange}
                            autoComplete="address-level2" />
                        <div className="error-text">{cityError}</div>
                    </Grid>
                    <Grid item xs={4}>
                        <div className="textfield-label">{formData.lang === "fr" ? "Code Postal" : "Postal Code"}</div>
                        <InputMask
                            mask='a9a9a9'
                            value={formData.postalCode}
                            disabled={false}
                            maskChar=""
                            onChange={onPostalCodeChange}>
                            {() => <TextField autoComplete="postal_code"/>}
                        </InputMask>
                        <div className="error-text">{postalError}</div>
                    </Grid>
                    <Grid item xs={3}>
                        <div className="textfield-label">Province</div>
                        <FormControl>
                            <Select
                                variant="outlined"
                                defaultValue='ON'
                                value={formData.state}
                                // value="QC"
                                onChange={onProvinceChange}
                                // disabled={true}
                            >
                                <MenuItem value={"NL"}>NL</MenuItem>
                                <MenuItem value={"PE"}>PE</MenuItem>
                                <MenuItem value={"NS"}>NS</MenuItem>
                                <MenuItem value={"NB"}>NB</MenuItem>
                                {/* <MenuItem value={"QC"}>QC</MenuItem> */}
                                <MenuItem value={"ON"}>ON</MenuItem>
                                <MenuItem value={"MB"}>MB</MenuItem>
                                <MenuItem value={"SK"}>SK</MenuItem>
                                <MenuItem value={"AB"}>AB</MenuItem>
                                <MenuItem value={"BC"}>BC</MenuItem>
                                <MenuItem value={"NU"}>NU</MenuItem>
                                <MenuItem value={"NT"}>NT</MenuItem>
                                <MenuItem value={"YT"}>YT</MenuItem>
                            </Select>
                        </FormControl>
                        <div className="error-text">{provinceError}</div>
                    </Grid>
                </Grid>

                {/* {showDisclaimer ?
                    <div className="quebec-resident-disclaimer">
                        For residents of Québec, the maximum loan amount available is $2,000. Any loan requests above this amount will be automatically adjusted to this limit.
                    </div> : null} */}

                <div className="textfield-label">Email</div>
                <TextField
                    // disabled={true}
                    type="email"
                    variant="outlined"
                    value={formData.email}
                    onChange={onEmailChange}
                    autoComplete="email" />
                <div className="error-text">{emailError}</div>
                <Grid container spacing={1}>
                    <Grid item xs={6}>
                        <div className="textfield-label">{formData.lang === "fr" ? "Téléphone" : "Phone"}</div>
                        <TextField
                            type="number"
                            variant="outlined"
                            value={formData.cellPhone}
                            onPaste={preventPaste}
                            onKeyDown={preventNonPositiveInteger}
                            onWheel={(e) => e.target.blur()}
                            onChange={onPhoneChange}
                            autoComplete="tel" />
                        <div className="error-text">{phoneError}</div>
                    </Grid>
                    <Grid item xs={6}>
                        <div className="textfield-label">{formData.lang === "fr" ? "Date de naissance" : "Date of Birth"}</div>
                        <TextField
                            InputProps={{ inputProps: { max: "9999-12-31" } }}
                            type="date"
                            onPaste={preventPaste}
                            variant="outlined"
                            value={formData.dob}
                            onChange={onBirthdateChange} />
                        <div className="error-text">{birthdateError}</div>
                    </Grid>
                </Grid>
                <div style={{ fontSize: 12, paddingTop: 10, paddingBottom: 10 }}>
                    {formData.lang === "fr" ? <span>En poursuivant ce formulaire, vous consentez, reconnaissez et acceptez notre <a href="https://www.insurdinary.ca/privacy-policy/" target="_blank" rel="noreferrer">politique de confidentialité</a>, y compris le partage des données de votre candidature avec le(s) partenaire(s) de Loans Canada, les données enregistrées à l'extérieur de la province de Québec, et Loans Canada et/ou ses autres partenaires contactant vous par téléphone, SMS (des frais peuvent s'appliquer en fonction de votre opérateur, pas par nous, la fréquence des messages varie) ou par e-mail pour répondre à (ou demander des commentaires) votre demande. Vous pouvez vous désinscrire à tout moment.</span> : <span>By continuing with this form, you consent, acknowledge, and agree to our <a href="https://www.insurdinary.ca/privacy-policy/" target="_blank" rel="noreferrer">privacy policy</a> including your application data being shared with Loans Canada's partner(s), data stored outside of the province of Quebec, and Loans Canada and/or its other partners contacting you by phone, SMS (charges may apply depending on your carrier, not by us, messaging frequency varies) or e-mail to respond to (or request feedback from) your request. You can opt-out at any time.</span>}
                </div>
                <Grid container spacing={1}>
                    <Grid item xs={6}>
                        <button className="nav-button"
                            onClick={() => {
                                setPage(page - 1);
                                moveToTop();
                            }}>
                            {formData.lang === "fr" ? "Précédent" : "Previous"}
                        </button>
                    </Grid>
                    <Grid item xs={6}>
                        <button className="nav-button"
                            onClick={() => {
                                validateData();
                            }}>
                            {formData.lang === "fr" ? "Suivant" : "Next"}
                        </button>
                    </Grid>
                </Grid>
            </div>
        </div>
    );
};

export default PersonalInfo;